// extracted by mini-css-extract-plugin
export default {"root":"aVfv0Cr4MbK19wzWy6yQ","prop":"OiEqPn5gfqeTE46tp2Td","placeHolderShimmer":"a986qZTZdiNTrcLdwEBP"};